import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Composant pour gérer les routes non trouvées
const NotFound = () => {
  const { isAuthenticated } = useAuth();
  
  // Rediriger vers la page d'accueil si authentifié, sinon vers la page de connexion
  return isAuthenticated ? <Navigate to="/" replace /> : <Navigate to="/sign-in" replace />;
};

export default NotFound;
